import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import PageTitle from "../components/pageTitle.js";

export default function BoardEdit() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");
  const [loading, setLoading] = useState(false);
  const baseUrl = process.env.REACT_APP_API_BASE_URL;

  useEffect(() => {
    axios.get(`${baseUrl}/api/board/${id}`)
      .then((res) => {
        setTitle(res.data.title);
        setContent(res.data.content);
      })
      .catch((err) => {
        console.error("❌ 게시글 조회 실패:", err);
        alert("게시글 정보를 불러오지 못했습니다.");
      });
  }, [id, baseUrl]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!title.trim() || !content.trim()) {
      alert("제목과 내용을 모두 입력해주세요.");
      return;
    }

    try {
      setLoading(true);
      await axios.put(`${baseUrl}/api/board/${id}`, {
        title,
        content,
      });
      alert("게시글이 수정되었습니다!");
      navigate("/services");
    } catch (err) {
      console.error("❌ 수정 실패:", err);
      alert("게시글 수정에 실패했습니다.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        maxWidth: "800px",
        margin: "0 auto",
        padding: "40px 20px",
        backgroundColor: "#fff",
        borderRadius: "8px",
        boxShadow: "0 2px 10px rgba(0,0,0,0.05)",
      }}
    >
      <div>
        <PageTitle title="치료 프로그램" />
      </div>

      <form onSubmit={handleSubmit}>
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <tbody>
            <tr style={{ borderBottom: "1px solid #eee" }}>
              <td style={{ padding: "10px", fontWeight: "bold" }}>
                제목<span style={{ color: "red" }}> *</span>
              </td>
              <td style={{ padding: "10px" }}>
                <input
                  type="text"
                  placeholder="제목을 입력하세요 (최대 100자)"
                  value={title}
                  onChange={(e) => setTitle(e.target.value)}
                  maxLength={100}
                  style={{
                    width: "100%",
                    padding: "10px",
                    border: "1px solid #ccc",
                    borderRadius: "4px",
                    fontSize: "16px",
                  }}
                />
              </td>
            </tr>

            <tr style={{ borderBottom: "1px solid #eee" }}>
              <td style={{ padding: "10px", fontWeight: "bold" }}>
                내용<span style={{ color: "red" }}> *</span>
              </td>
              <td style={{ padding: "10px" }}>
                <textarea
                  placeholder="내용을 입력하세요 (최대 4000자)"
                  value={content}
                  onChange={(e) => setContent(e.target.value)}
                  rows={10}
                  maxLength={4000}
                  style={{
                    width: "100%",
                    padding: "10px",
                    border: "1px solid #ccc",
                    borderRadius: "4px",
                    fontSize: "16px",
                    resize: "vertical",
                  }}
                />
                <div style={{ textAlign: "right", fontSize: "12px", color: "#666" }}>
                  {content.length}/4000
                </div>
              </td>
            </tr>
          </tbody>
        </table>

        <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "30px", gap: "10px" }}>
          <button
            type="button"
            onClick={() => navigate("/services")}
            style={{
              padding: "10px 20px",
              backgroundColor: "#98bcc9",
              color: "white",
              borderRadius: "0px",
              fontSize: "16px",
              cursor: "pointer"
            }}
          >
            취소
          </button>
          <button
            type="submit"
            disabled={loading}
            style={{
              padding: "10px 20px",
              backgroundColor: loading ? "#ccc" : "#98bcc9",
              color: "white",
              border: "none",
              borderRadius: "0px",
              fontSize: "16px",
              cursor: loading ? "not-allowed" : "pointer"
            }}
          >
            {loading ? "수정 중..." : "수정"}
          </button>
        </div>
      </form>
    </div>
  );
}
